import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FaPlus, FaMinus } from 'react-icons/fa';
import OtherAppointmentForm from '../OtherAppointmentForm';

/**
 * OtherAppointmentsFormコンポーネント用のPropsです。
 * @interface OtherAppointmentsFormProps
 */
interface OtherAppointmentsFormProps {
  
  /**
   * その他の委任事項（複数）
   * @type {string[]}
   * @memberof OtherAppointmentFormProps
   */
  otherAppointments: string[];

  /**
   * その他の委任事項を設定する関数
   * @memberof OtherAppointmentFormProps
   */
  onChange: (otherAppointments: string[]) => void;

}

/**
 * その他の委任事項（複数）フォームのコンポーネントです。
 * @param {string} props.otherAppointments - その他の委任事項（複数）
 * @param {function} props.onChange - その他の委任事項（複数）が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - その他の委任事項（複数）フォームのJSX要素
 */
const OtherAppointmentsForm: React.FC<OtherAppointmentsFormProps> = ({ otherAppointments, onChange }) => {

  /**
   * その他の委任事項フォームを追加する関数です。
   * @param {string} addedOtherAppointment - その他の委任事項
   * @returns {void}
   */
  const addOtherAppointment = (addedOtherAppointment: string): void => {
    onChange([...otherAppointments, addedOtherAppointment]);
  }

  /**
   * その他の委任事項フォームを削除する関数です。
   * @param {number} removedOtherAppointmentIndex - 削除するその他の委任事項の索引
   * @returns {void}
   */
  const deleteOtherAppointment = (removedOtherAppointmentIndex: number): void => {
    if(removedOtherAppointmentIndex !== 0) {
      onChange(
        otherAppointments.filter((_otherAppointment, i) => (i !== removedOtherAppointmentIndex))
      )
    }
  }

  /**
   * その他の委任事項フォームを更新する関数です。
   * @param {number} updatedOtherAppointmentIndex - 更新するその他の委任事項の索引
   * @param {string} updatedOtherAppointment - 更新するその他の委任事項
   * @returns {void}
   */
  const updateOtherAppointment = (updatedOtherAppointmentIndex: number, updatedOtherAppointment: string): void => {
    onChange(
      otherAppointments.map((otherAppointment, i) => (i === updatedOtherAppointmentIndex ? updatedOtherAppointment : otherAppointment))
    )
  }

  return (
    <>
      <Form.Label>
        その他の委任事項
        <span className="text-small text-secondary ms-3">※任意</span>
      </Form.Label>
      <div className="text-end" style={{marginTop: '-2rem'}}>
        <div className="mx-1 d-inline">
          <Button
            variant='primary'
            className="rounded-circle py-1 px-2 btn-sm text-white"
            onClick={() => {addOtherAppointment('');}}
            >
            <FaPlus />
          </Button>
        </div>
        <div className="mx-1 d-inline">
          <Button
            variant="danger"
            className="rounded-circle py-1 px-2 btn-sm text-white" 
            onClick={() => {deleteOtherAppointment(otherAppointments.length-1);}}
            disabled={otherAppointments.length === 1 ? true : false}
          >
            <FaMinus />
          </Button>
        </div>
      </div>
      {otherAppointments.map((otherAppointment, index) => {
        return (
          <div key={index} className="my-2">
            <OtherAppointmentForm
              index={index}
              otherAppointment={otherAppointment}
              onChange={updateOtherAppointment}
            />
          </div>
        );
      })}
    </>
  );
}

export default OtherAppointmentsForm;